import { render } from "./TipRecord.vue?vue&type=template&id=7a2cbf5c&scoped=true"
import script from "./TipRecord.vue?vue&type=script&lang=js"
export * from "./TipRecord.vue?vue&type=script&lang=js"

import "./TipRecord.vue?vue&type=style&index=0&id=7a2cbf5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2cbf5c"]])

export default __exports__